export default __webpack_public_path__ + "static/media/search.248f8ba7.svg";